import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
// import SettingsMenu from "@components/library/Sidebar/components/themeMenu";
import {
  LogoutIcon,
  ProfileIcon,
  FinanceIcon,
  SupportIcon,
  TradingIcon,
  MarketsIcon,
  SettingsIcon,
  IosAppIcon,
  DesktopVersionIcon,
  // WalletIcon,
} from "@components/library";
import { Button } from "@components/library";
import BlockIcon from "@assets/icons/BlockIcon";
import { useDispatch, useSelector } from "react-redux";
import { removeUserSession } from "@helpers/axios/private.axios";
import { useTranslation } from "@helpers/translate";
import {
  AUTH,
  NAV_ITEMS_SIDEBAR,
  NAV_ITEMS_DROPDOWN,
  // IOS_APP_NAV_ITEM,
  // DESKTOP_VERSION_NAV_ITEM,
} from "@constants";
import "./MobileSidebar.sass";
import UserAccountSummary from "../../layout/Header/components/UserAccountSummary";
import LanguageDropdown from "../../layout/Header/components/LanguageDropdown";

const MobileSidebar = ({ open, setOpen }) => {
  // const [settingsOpen, setSettingsOpen] = useState(false);
  const { isDemoUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { __ } = useTranslation();

  const openSupportChat = () => {
    document.getElementById("sendpulse-chat-wrapper")?.classList.add("active");
  };

  const mobileIconByKey = {
    trading: <TradingIcon />,
    finance: <FinanceIcon />,
    profile: <ProfileIcon />,
    markets: <MarketsIcon />,
    support: <SupportIcon />,
    settings: <SettingsIcon />,
    ios_app: <IosAppIcon />,
    desktop_version: <DesktopVersionIcon />,
  };

  const settingsNavItem = NAV_ITEMS_DROPDOWN.find(
    (item) => item.key === "settings",
  );

  const logout = () => {
    navigate("/");
    removeUserSession();
  };

  const openAuthPopup = () => {
    dispatch({ type: AUTH.AUTH_CHANGE_POPUP, payload: true });
  };

  // const handleDesktopVersion = () => {
  //   /* заглушка: перемикання мобільна → десктопна версія */
  // };

  const renderNavItem = (item) => {
    const { key, to, textKey, authRequired, isDisabled, icon } = item;

    if (isDemoUser && authRequired) {
      return (
        <li key={key} className="mobile-sidebar__item">
          <button
            type="button"
            onClick={openAuthPopup}
            className="mobile-sidebar__nav-link"
          >
            <span className="mobile-sidebar__nav-icon">
              {mobileIconByKey[icon]}
            </span>
            <p className="mobile-sidebar__nav-text">{__(textKey)}</p>
          </button>
        </li>
      );
    }

    if (item.isSidebarAction) {
      return (
        <li key={key} className="mobile-sidebar__item">
          <button
            type="button"
            className="mobile-sidebar__nav-link"
            onClick={() => {
              if (isDisabled) return;

              setOpen(false);

              if (key === "support_mobile") {
                openSupportChat();
              }
            }}
            aria-disabled={isDisabled ? "true" : "false"}
            tabIndex={isDisabled ? -1 : 0}
          >
            <span
              className={`mobile-sidebar__nav-icon${
                isDisabled ? " mobile-sidebar__nav-icon--disabled" : ""
              }`}
            >
              {mobileIconByKey[icon]}
            </span>
            <p
              className={`mobile-sidebar__nav-text${
                isDisabled ? " mobile-sidebar__nav-text--disabled" : ""
              }`}
            >
              {__(textKey)}
            </p>
            {isDisabled && (
              <div className="mobile-sidebar__disabled">
                <BlockIcon />
                <span className="mobile-sidebar__disabled-text">
                  {__("common.coming-soon")}
                </span>
              </div>
            )}
          </button>
        </li>
      );
    }

    return (
      <li key={key} className="mobile-sidebar__item">
        <NavLink
          end={key === "profile"}
          onClick={(e) => {
            if (isDisabled) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            setOpen(false);
          }}
          to={to}
          aria-disabled={isDisabled ? "true" : "false"}
          tabIndex={isDisabled ? -1 : 0}
          className={({ isActive }) =>
            `mobile-sidebar__nav-link${
              isActive && !isDisabled ? " active" : ""
            }`
          }
        >
          <span
            className={`mobile-sidebar__nav-icon${
              isDisabled ? " mobile-sidebar__nav-icon--disabled" : ""
            }`}
          >
            {mobileIconByKey[icon]}
          </span>
          <p
            className={`mobile-sidebar__nav-text${
              isDisabled ? " mobile-sidebar__nav-text--disabled" : ""
            }`}
          >
            {__(textKey)}
          </p>
          {isDisabled && (
            <div className="mobile-sidebar__disabled">
              <BlockIcon />
              <span className="mobile-sidebar__disabled-text">
                {__("common.coming-soon")}
              </span>
            </div>
          )}
        </NavLink>
      </li>
    );
  };

  return (
    <aside
      onClick={() => setOpen(false)}
      className={`mobile-sidebar${open ? " active" : ""}`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="mobile-sidebar__wrapper"
      >
        <header className="mobile-sidebar__header">
          <UserAccountSummary />

          <Button
            className="mobile-sidebar__deposit header__deposit"
            type="button"
            onClick={() => {
              setOpen(false);
              navigate("/wallet/deposit");
            }}
            color="orange"
            size="mini"
          >
            {__("common.deposit_header_btn")}
          </Button>
        </header>

        <nav>
          <ul className="mobile-sidebar__list">
            {NAV_ITEMS_SIDEBAR.map((item) => renderNavItem(item))}

            <div className="mobile-sidebar__line"></div>

            <li className="mobile-sidebar__item mobile-sidebar__item--lang">
              <LanguageDropdown variant="mobile-sidebar" />
            </li>

            {settingsNavItem && renderNavItem(settingsNavItem)}

            {/* {renderNavItem(IOS_APP_NAV_ITEM)} */}

            {/* {renderNavItem(DESKTOP_VERSION_NAV_ITEM)} */}

            {!isDemoUser && (
              <li className="mobile-sidebar__item">
                <button
                  onClick={logout}
                  type="button"
                  className="mobile-sidebar__nav-link"
                >
                  <LogoutIcon className="mobile-sidebar__nav-icon" />
                  <p className="mobile-sidebar__nav-text">
                    {__("common.logout")}
                  </p>
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default MobileSidebar;
